export default "__VITE_ASSET__VXGa8XY$__"